import React from 'react';
import { Route, Switch } from 'react-router-dom';

import AttributeManagement from './AttributeManagement/AttributeManagement';
import ExecutiveSummary from './ExecutiveSummary/ExecutiveSummary';
import CompanyPage from './CompanyPage/CompanyPage';
import Conversions from './Conversions/Conversions';
import ClientPage from './ClientPage/ClientPage';
import SitePage from './SitePage/SitePage';
import IotHub from './IotHub/IotHub';
import EquipmentPage from './EquipmentPage/EquipmentPage';
import SystemPage from './SystemPage/SystemPage';
import ServiceManagement from './ServiceManagement/ServiceManagement';
import SensorPage from './SensorPage/SensorPage';
import UserPage from './Users/UserPage';
import BackgroundJobsPage from './BackgroundJobs/BackgroundJobsPage';
import AnnouncementsPage from './Announcements/AnnouncementsPage';
import ReportPage from './Reports/ReportPage';
import CompanyManagement from './CompanyManagement/CompanyManagement';
import ConfigureAgentPage from './IotHub/ConfigureAgentPage/ConfigureAgentPage';
import ManageAgentPage from './IotHub/ManageAgentPage/ManageAgentPage';
import EntitiesPage from './Core/EntitiesPage';
import EntityManagePage from './Core/EntityManagePage';
import LookupManagement from './LookupManagement/LookupManagement';
import ManageContactsPage from './Contacts/ManageContactPage';
import RulesPage from './Rules/RulesPage';
import CalculatedSensor from './CalculatedSensor/CalculatedSensor';
import ConfigurationPage from './Configuration/ConfigurationPage';
import RolesPage from './Roles/RolesPage';
import EnergyPage from './Energy/EnergyPage';

import classes from './Dashboard.module.css';

const Dashboard = ({
    ...props
}) => {

    return (
        <div className={classes.Dashboard}>
            <Switch>
                <Route
                    path="/v2/dashboard/attributemanagement"
                    render={(routeProps) => (
                        <AttributeManagement />
                    )}
                />
                <Route
                    path="/v2/dashboard/executivesummary"
                    render={(routeProps) => (
                        <ExecutiveSummary />
                    )}
                />
                <Route
                    path="/v2/dashboard/energy"
                    render={(routeProps) => (
                        <EnergyPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/core/entities/manage"
                    render={(routeProps) => (
                        <EntityManagePage />
                    )}
                />
                <Route
                    path="/v2/dashboard/core/entities"
                    render={(routeProps) => (
                        <EntitiesPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/contacts"
                    render={(routeProps) => (
                        <ManageContactsPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/conversions"
                    render={(routeProps) => (
                        <Conversions />
                    )}
                />
                <Route
                    path="/v2/dashboard/company"
                    render={(routeProps) => (
                        <CompanyPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/client"
                    render={(routeProps) => (
                        <ClientPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/site"
                    render={(routeProps) => (
                        <SitePage />
                    )}
                />
                <Route
                    path="/v2/dashboard/equipment/sensor"
                    render={(routeProps) => (
                        <SensorPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/calculated/sensor"
                    render={(routeProps) => (
                        <CalculatedSensor />
                    )}
                />
                <Route
                    path="/v2/dashboard/equipment"
                    render={(routeProps) => (
                        <EquipmentPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/system/sensor"
                    render={(routeProps) => (
                        <SensorPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/system"
                    render={(routeProps) => (
                        <SystemPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/servicemanagement"
                    render={(routeProps) => (
                        <ServiceManagement />
                    )}
                />
                <Route
                    path="/v2/dashboard/users"
                    render={(routeProps) => (
                        <UserPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/announcements"
                    render={(routeProps) => (
                        <AnnouncementsPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/reports"
                    render={(routeProps) => (
                        <ReportPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/iothub/configure"
                    render={(routeProps) => (
                        <ConfigureAgentPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/iothub/manage"
                    render={(routeProps) => (
                        <ManageAgentPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/iothub"
                    render={(routeProps) => (
                        <IotHub />
                    )}
                />
                <Route
                    path="/v2/dashboard/processes"
                    render={(routeProps) => (
                        <BackgroundJobsPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/companymanagement"
                    render={(routeProps) => (
                        <CompanyManagement />
                    )}
                />
                <Route
                    path="/v2/dashboard/lookups"
                    render={(routeProps) => (
                        <LookupManagement />
                    )}
                />
                <Route
                    path="/v2/dashboard/rules"
                    render={(routeProps) => (
                        <RulesPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/configuration"
                    render={(routeProps) => (
                        <ConfigurationPage />
                    )}
                />
                <Route
                    path="/v2/dashboard/roles"
                    render={(routeProps) => (
                        <RolesPage />
                    )}
                />
            </Switch>
        </div>
    );
};

export default Dashboard;
